export default {
  elements: {},
  init() {
    var offences = function () {
      this.maxSentence = 5;
      this.band = "A";
      this.startingPoint = { value: "50", label: "50%" };
      this.plea = 3;
      this.beforePlea = 60;
      this.afterPlea = 0;
      this.compensation = 0;
    };

    function logArrayElements(element, index, array) {
      console.log("offence[" + index + "] = " + element.band);
    }

    var app = angular.module("sentencing", []);

    app.config(function ($interpolateProvider) {
      $interpolateProvider.startSymbol("<%");
      $interpolateProvider.endSymbol("%>");
    });

    app.controller("SentencingCtrl", function ($timeout, $scope) {
      ////////////////////
      // Default Values //
      ////////////////////

      $scope.allOffences = [];
      $scope.selectedOffence = 0;
      $scope.allOffences.push(new offences());
      $scope.name = "";

      $scope.data = {
        availableOptions: [
          { value: "20", label: "20%" },
          { value: "25", label: "25%" },
          { value: "30", label: "30%" },
          { value: "35", label: "35%" },
          { value: "40", label: "40%" },
          { value: "45", label: "45%" },
          { value: "50", label: "50%" },
          { value: "55", label: "55%" },
          { value: "60", label: "60%" },
          { value: "65", label: "65%" },
          { value: "70", label: "70%" },
          { value: "75", label: "75%" },
        ],
      };

      $scope.income = "£ 120";
      $scope.cIncome = 120;
      $scope.cIncomeRange = 1;
      $scope.incomeRange = "weekly";

      $scope.allOffences[$scope.selectedOffence].maximumSentence = 5;

      $scope.victimSurcharge = 10;
      $scope.cCost = 0;
      $scope.cCostView = 0;
      // $scope.plea = 3;
      $scope.pleaValue = parseFloat(1 / 3);
      $scope.pleaPercent = "";

      $scope.iAmountHolder = "";
      $scope.cAmountHolder = "";
      $scope.vsAmountHolder = "";
      $scope.ccAmountHolder = "";

      $scope.allOffences[$scope.selectedOffence].afterPlea =
        ($scope.cIncome *
          $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
          $scope.cIncomeRange /
          100 -
        ((($scope.cIncome / $scope.cIncomeRange) *
          $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
          100) *
          $scope.pleaValue;
      $scope.surcharge = 0;
      $scope.cSurcharge = 0;
      $scope.cSurchargeView = 0;
      jQuery(".offence-button-container").hide();
      jQuery(".surcharge-info").hide();

      //////////////////////
      // Helper Functions //
      //////////////////////

      $scope.focusOut = function () {
        console.log("Focusing Out");
      };

      $scope.translate = function (value) {
        return value + "%";
      };

      $scope.parseFloatFunc = function (
        $cost,
        $courtSur,
        $ccCharge,
        $surCharge,
        $comp
      ) {
        if (!$courtSur) {
          $courtSur = "£0";
        }
        if (!$ccCharge) {
          $ccCharge = "£0";
        }
        if (!$surCharge) {
          $surCharge = "£0";
        }
        if (!$comp) {
          $comp = "£0";
        }
        return (
          parseFloat($cost) +
          parseFloat($courtSur.replace("£", "")) +
          parseFloat($ccCharge.replace("£", "")) +
          parseFloat($surCharge.replace("£", "")) +
          parseFloat($comp.replace("£", ""))
        );
      };

      //////////////////////////
      // Calculator Functions //
      //////////////////////////

      $scope.updateMaximumSentence = function () {
        let gbp = $scope.allOffences[$scope.selectedOffence].beforePlea;
        let ms = $scope.allOffences[$scope.selectedOffence].maximumSentence;
        console.log("Gbp and Plea: " + gbp + " - " + $scope.pleaValue);

        if (gbp >= 200 && ms == 1) {
          $scope.allOffences[$scope.selectedOffence].beforePlea = 200;
          // if($scope.allOffences[$scope.selectedOffence].afterPlea >= 200)
          // {
          $scope.allOffences[$scope.selectedOffence].afterPlea =
            200 -
            $scope.allOffences[$scope.selectedOffence].beforePlea *
              $scope.pleaValue;
          // }
        }

        if (gbp >= 500 && ms == 2) {
          $scope.allOffences[$scope.selectedOffence].beforePlea = 500;
          // if($scope.allOffences[$scope.selectedOffence].afterPlea >= 500)
          // {
          $scope.allOffences[$scope.selectedOffence].afterPlea =
            500 -
            $scope.allOffences[$scope.selectedOffence].beforePlea *
              $scope.pleaValue;
          // }
        }

        if (gbp >= 1000 && ms == 3) {
          $scope.allOffences[$scope.selectedOffence].beforePlea = 1000;
          // if($scope.allOffences[$scope.selectedOffence].afterPlea >= 1000)
          // {
          //   console.log("BeforePlea Value ="+$scope.allOffences[$scope.selectedOffence].beforePlea);
          //   console.log("Plea Value ="+$scope.pleaValue);
          //   console.log("After Plea: "+ ($scope.allOffences[$scope.selectedOffence].beforePlea * $scope.pleaValue ));
          $scope.allOffences[$scope.selectedOffence].afterPlea =
            1000 -
            $scope.allOffences[$scope.selectedOffence].beforePlea *
              $scope.pleaValue;
          //   console.log("After Plea Subtracted: "+ $scope.allOffences[$scope.selectedOffence].afterPlea);
          // }
        }

        if (gbp >= 2500 && ms == 4) {
          $scope.allOffences[$scope.selectedOffence].beforePlea = 2500;
          // if($scope.allOffences[$scope.selectedOffence].afterPlea >= 2500)
          // {
          $scope.allOffences[$scope.selectedOffence].afterPlea =
            2500 -
            $scope.allOffences[$scope.selectedOffence].beforePlea *
              $scope.pleaValue;
          // }
        }
      };

      $scope.updateOffences = function () {
        angular.forEach($scope.allOffences, function (value, key) {
          //$scope.allOffences[key].afterPlea = $scope.cIncome - ($scope.cIncome / $scope.allOffences[key].plea);
          //$scope.afterPleaFunc($scope.allOffences[key].plea);
          // console.log("Offence#: "+key);
          //     console.log("Before Plea: "+value.beforePlea);
          //     console.log("Calculated After Plea: "+ $scope.allOffences[key].afterPlea);
          //     console.log("After Plea: "+value.afterPlea);
          //     console.log("Income: "+$scope.cIncome);
          $scope.selectOffence(key + 1);
        });
      };

      $scope.beforePleaFunc = function ($value) {
        //console.log("Value = " + $value);
        if (
          $value != $scope.cIncome &&
          typeof $value != "undefined" &&
          $value !== ""
        ) {
          $scope.cIncome = $value;
          $scope.income = "£ " + $value;
        } else {
          $value = "£ " + $scope.iAmountHolder;
          $scope.income = $value;
        }

        $scope.cIncome = $value.replace("£", "");
        $scope.allOffences[$scope.selectedOffence].afterPlea =
          $scope.cIncome -
          $scope.cIncome / $scope.allOffences[$scope.selectedOffence].plea;
        $scope.updatePlea();
        $scope.updateOffences();
        $scope.refreshMobileSummary();
        $scope.refreshMobileSummary2();
        //$scope.allOffences.forEach(updateOffences);
      };

      $scope.afterPleaFunc = function ($value) {
        console.log("AfterPleaFunction Value = " + $value);
        if ($value == 10) {
          $scope.pleaValue = $value / 100;
          $scope.updatePlea();
        } else {
          if ($value != 0) {
            $scope.pleaValue = 1 / $value;
            $scope.updatePlea();
          } else {
            $scope.pleaValue = 0;
            $scope.updatePlea();
          }
        }
      };

      $scope.afterPleaPercent = function ($value) {
        $scope.allOffences[$scope.selectedOffence].plea = "";
        $scope.pleaValue = $value / 100;
      };

      ///////////////////////
      //     Selection     //
      ///////////////////////

      $scope.prosecutionCostFunc = function ($value) {
        $scope.cCost = $value;
        $scope.cCostView = $value;
      };

      // Need to update this function
      $scope.surchargeFunc = function ($value, $state) {
        var afterPlea = "";
        if ($state == "after") {
          if ($value == "%10%") {
            //afterPlea = $scope.getBiggestAfterPlea();
            afterPlea = $scope.getTotalAterPlea();
            if (afterPlea) {
              if (afterPlea < 34) {
                $scope.victimSurcharge = "34";
                $scope.cSurcharge = "34";
                $scope.cSurchargeView = "34";
              } else if (afterPlea > 190) {
                $scope.victimSurcharge = "190";
                $scope.cSurcharge = "190";
                $scope.cSurchargeView = "190";
              } else {
                $scope.victimSurcharge = afterPlea.toString();
                $scope.cSurcharge = afterPlea.toString();
                $scope.cSurchargeView = afterPlea.toString();
              }
            }
          } else {
            $scope.victimSurcharge = $value;
            $scope.cSurcharge = $value;
            $scope.cSurchargeView = $value;
          }
          if ($value == "0") {
            jQuery(".vc-height").height(5);
            $scope.vs_description = "";
          }
          if ($value == "17") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Conditional Discharge (offender under 18 at date of offence)";
          }
          if ($value == "22") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Conditional Discharge (offender 18 or over at date of offence). A fine, Youth Rehabilitation Order, Referral Order or Community Order (offender under 18 at date of offence).";
          }
          if ($value == "34") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Suspended Sentence Order or Detention and Training Order (offender under 18 at date of offence)";
          }
          if ($value == "95") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Community Order (offender 18 or over at date of offence).";
          }
          if ($value == "128") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order 6 months or less (offender 18 or over at date of offence).";
          }
          if ($value == "156") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order over 6 months (offender 18 or over at date of offence).";
          }
          if ($value == "%10%") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Minimum amount of £34 and a maximum amount of £190 (offender 18 or over at date of offence)";
          }
        } else if ($state == "2020") {
          if ($value == "40%") {
            //afterPlea = $scope.getBiggestAfterPlea();
            afterPlea = $scope.getTotalAterPlea40();
            if (afterPlea) {
              // if (afterPlea < 34) {
              //   $scope.victimSurcharge = "34";
              //   $scope.cSurcharge = "34";
              //   $scope.cSurchargeView = "34";
              // } else
              if (afterPlea > 2000) {
                $scope.victimSurcharge = "2000";
                $scope.cSurcharge = "2000";
                $scope.cSurchargeView = "2000";
              } else {
                $scope.victimSurcharge = afterPlea.toString();
                $scope.cSurcharge = afterPlea.toString();
                $scope.cSurchargeView = afterPlea.toString();
              }
            }
          } else {
            $scope.victimSurcharge = $value;
            $scope.cSurcharge = $value;
            $scope.cSurchargeView = $value;
          }
          if ($value == "0") {
            jQuery(".vc-height").height(5);
            $scope.vs_description = "";
          }
          if ($value == "20") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Conditional Discharge (offender under 18 at date of offence).";
          }
          if ($value == "26") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Conditional Discharge (offender 18 or over at date of offence). A fine, Youth Rehabilitation Order, Referral Order or Community Order (offender under 18 at date of offence).";
          }
          if ($value == "41") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Suspended Sentence Order or Detention and Training Order (offender under 18 at date of offence)";
          }
          if ($value == "114") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Community Order (offender 18 or over at date of offence).";
          }
          if ($value == "154") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order 6 months or less (offender 18 or over at date of offence).";
          }
          if ($value == "187") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order over 6 months (offender 18 or over at date of offence).";
          }
          if ($value == "40%") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Minimum amount of no minimum and a maximum amount of £2000 (offender 18 or over at date of offence)";
          }
        } else {
          if ($value == "10%") {
            //afterPlea = $scope.getBiggestAfterPlea();
            afterPlea = $scope.getTotalAterPlea();
            if (afterPlea) {
              if (afterPlea < 32) {
                $scope.victimSurcharge = "32";
                $scope.cSurcharge = "32";
                $scope.cSurchargeView = "32";
              } else if (afterPlea > 181) {
                $scope.victimSurcharge = "181";
                $scope.cSurcharge = "181";
                $scope.cSurchargeView = "181";
              } else {
                $scope.victimSurcharge = afterPlea.toString();
                $scope.cSurcharge = afterPlea.toString();
                $scope.cSurchargeView = afterPlea.toString();
              }
            }
          } else {
            $scope.victimSurcharge = $value;
            $scope.cSurcharge = $value;
            $scope.cSurchargeView = $value;
          }
          if ($value == "0") {
            jQuery(".vc-height").height(5);
            $scope.vs_description = "";
          }
          if ($value == "16") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Conditional Discharge (offender under 18 at date of offence).";
          }
          if ($value == "21") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Conditional Discharge (offender 18 or over at date of offence). A fine, Youth Rehabilitation Order, Referral Order or Community Order (offender under 18 at date of offence).";
          }
          if ($value == "32") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Suspended Sentence Order or Detention and Training Order (offender under 18 at date of offence)";
          }
          if ($value == "90") {
            jQuery(".vc-height").height(105);
            $scope.vs_description =
              "Community Order (offender 18 or over at date of offence).";
          }
          if ($value == "122") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order 6 months or less (offender 18 or over at date of offence).";
          }
          if ($value == "149") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Imprisonment or Suspended Sentence Order over 6 months (offender 18 or over at date of offence).";
          }
          if ($value == "10%") {
            jQuery(".vc-height").height(129);
            $scope.vs_description =
              "Minimum amount of £32 and a maximum amount of £181 (offender 18 or over at date of offence)";
          }
        }
      };

      ////////////////////////
      //       FOCUS       //
      //////////////////////

      $scope.focusIncome = function ($value) {
        var isnum = /^\d+$/.test($value);
        if (!isnum && typeof $value !== "undefined") {
          $scope.iAmountHolder = $value.replace("£ ", "");
        } else {
          if (typeof $value !== "undefined") {
            $scope.iAmountHolder = $value;
          }
        }
        //$scope.cIncomeView="";
        $scope.cIncome = "";
        $scope.income = "";
      };

      $scope.focusCompensation = function ($value) {
        var isnum = /^\d+$/.test($value);
        if (!isnum && typeof $value !== "undefined") {
          $scope.cAmountHolder = $value.replace("£ ", "");
        } else {
          if (typeof $value !== "undefined") {
            $scope.cAmountHolder = $value;
          }
        }
        $scope.allOffences[$scope.selectedOffence].compensation = "";
        $scope.cCompensationView = "";
        $scope.cCompensation = "";
      };

      $scope.focusSurcharge = function ($value) {
        var isnum = /^\d+$/.test($value);
        if (!isnum && typeof $value !== "undefined") {
          $scope.vsAmountHolder = $value.replace("£ ", "");
        } else {
          if (typeof $value !== "undefined") {
            $scope.vsAmountHolder = $value;
          }
        }
        $scope.cSurchargeView = "";
      };

      $scope.focusProsecutionCost = function ($value) {
        var isnum = /^\d+$/.test($value);
        if (!isnum && typeof $value !== "undefined") {
          $scope.ccAmountHolder = $value.replace("£ ", "");
        } else {
          if (typeof $value !== "undefined") {
            $scope.ccAmountHolder = $value;
          }
        }
        $scope.cCostView = "";
      };

      ////////////////////////
      //    Deselection    //
      //////////////////////

      $scope.deselectProsecutionCost = function ($value) {
        if (
          $value != $scope.cCost &&
          typeof $value != "undefined" &&
          $value !== ""
        ) {
          $scope.prosecutionCost = "";
          $scope.cCost = $value;
        } else {
          $scope.cCostView = "£ " + $scope.ccAmountHolder;
        }
      };

      $scope.deselectSurcharge = function ($value) {
        if (
          $value != $scope.cSurcharge &&
          typeof $value != "undefined" &&
          $value !== ""
        ) {
          $scope.surcharge = "";
          $scope.cSurcharge = Math.floor($value);
          $scope.vs_description = "";
          jQuery(".vc-height").height(75);
        } else {
          $scope.cSurchargeView = "£ " + Math.floor($scope.vsAmountHolder);
        }
      };

      $scope.deselectCompensation = function ($value) {
        //console.log($value);
        if (
          $value != $scope.cCompensation &&
          typeof $value != "undefined" &&
          $value !== ""
        ) {
          $scope.cCompensation = $value;
          $scope.cCompensationView = $value;
        } else {
          $scope.cCompensationView = "£ " + $scope.cAmountHolder;
          $scope.cCompensation = "£ " + $scope.cAmountHolder;
          $scope.allOffences[$scope.selectedOffence].compensation =
            $scope.cAmountHolder;
        }
      };

      ////////////////////////////
      //    Band Calculator    //
      //////////////////////////

      $scope.bandRangeFunc = function ($setDefault) {
        if ($scope.allOffences[$scope.selectedOffence].band == "None") {
          $scope.hideFineFields(true);
          $scope.allOffences[$scope.selectedOffence].startingPoint.value = 0;
          $scope.allOffences[$scope.selectedOffence].startingPoint = {
            value: "0",
            label: "",
          };
          $scope.allOffences[$scope.selectedOffence].plea = 0;
          $scope.allOffences[$scope.selectedOffence].beforePlea = 0;
          $scope.allOffences[$scope.selectedOffence].afterPlea = 0;
          jQuery(".startigPoint").hide();
          jQuery(".guiltyplea").hide();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "A") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "20", label: "20%" },
              { value: "25", label: "25%" },
              { value: "30", label: "30%" },
              { value: "35", label: "35%" },
              { value: "40", label: "40%" },
              { value: "45", label: "45%" },
              { value: "50", label: "50%" },
              { value: "55", label: "55%" },
              { value: "60", label: "60%" },
              { value: "65", label: "65%" },
              { value: "70", label: "70%" },
              { value: "75", label: "75%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[$scope.selectedOffence].startingPoint.value = 50;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "50",
              label: "50%",
            };
          }
          $scope.updatePlea();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "B") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "75", label: "75%" },
              { value: "80", label: "80%" },
              { value: "85", label: "85%" },
              { value: "90", label: "90%" },
              { value: "95", label: "95%" },
              { value: "100", label: "100%" },
              { value: "105", label: "105%" },
              { value: "110", label: "110%" },
              { value: "115", label: "115%" },
              { value: "120", label: "120%" },
              { value: "125", label: "125%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[
              $scope.selectedOffence
            ].startingPoint.value = 100;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "100",
              label: "100%",
            };
          }
          $scope.updatePlea();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "C") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "125", label: "125%" },
              { value: "130", label: "130%" },
              { value: "135", label: "135%" },
              { value: "140", label: "140%" },
              { value: "145", label: "145%" },
              { value: "150", label: "150%" },
              { value: "155", label: "155%" },
              { value: "160", label: "160%" },
              { value: "165", label: "165%" },
              { value: "170", label: "170%" },
              { value: "175", label: "175%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[
              $scope.selectedOffence
            ].startingPoint.value = 150;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "150",
              label: "150%",
            };
          }
          $scope.updatePlea();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "D") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "200", label: "200%" },
              { value: "210", label: "210%" },
              { value: "220", label: "220%" },
              { value: "230", label: "230%" },
              { value: "240", label: "240%" },
              { value: "250", label: "250%" },
              { value: "260", label: "260%" },
              { value: "270", label: "270%" },
              { value: "280", label: "280%" },
              { value: "290", label: "290%" },
              { value: "300", label: "300%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[
              $scope.selectedOffence
            ].startingPoint.value = 250;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "250",
              label: "250%",
            };
          }
          $scope.updatePlea();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "E") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "300", label: "300%" },
              { value: "320", label: "320%" },
              { value: "340", label: "340%" },
              { value: "360", label: "360%" },
              { value: "380", label: "380%" },
              { value: "400", label: "400%" },
              { value: "420", label: "420%" },
              { value: "440", label: "440%" },
              { value: "460", label: "460%" },
              { value: "480", label: "480%" },
              { value: "500", label: "500%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[
              $scope.selectedOffence
            ].startingPoint.value = 400;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "400",
              label: "400%",
            };
          }
          $scope.updatePlea();
        }
        if ($scope.allOffences[$scope.selectedOffence].band == "F") {
          jQuery(".startigPoint").show();
          jQuery(".guiltyplea").show();
          $scope.hideFineFields(false);
          $scope.data = {
            availableOptions: [
              { value: "500", label: "500%" },
              { value: "520", label: "520%" },
              { value: "540", label: "540%" },
              { value: "560", label: "560%" },
              { value: "580", label: "580%" },
              { value: "600", label: "600%" },
              { value: "620", label: "620%" },
              { value: "640", label: "640%" },
              { value: "660", label: "660%" },
              { value: "680", label: "680%" },
              { value: "700", label: "700%" },
            ],
          };
          if ($setDefault == "true") {
            $scope.allOffences[
              $scope.selectedOffence
            ].startingPoint.value = 600;
            $scope.allOffences[$scope.selectedOffence].startingPoint = {
              value: "600",
              label: "600%",
            };
          }
          $scope.updatePlea();
        }
      };

      /////////////////////////
      //    Income range    //
      ///////////////////////

      $scope.incomeRangeFunc = function ($incomeRange) {
        if ($incomeRange == "annually") {
          $scope.cIncomeRange = 52.083333333;
        } else if ($incomeRange == "monthly") {
          $scope.cIncomeRange = 4.332755633;
        } else if ($incomeRange == "biweekly") {
          $scope.cIncomeRange = 2;
        } else if ($incomeRange == "weekly") {
          $scope.cIncomeRange = 1;
        } else if ($incomeRange == "120") {
          $scope.cIncomeRange = 1;
          $scope.incomeRange = "weekly";
          $scope.income = "£ 120";
          $scope.cIncome = 120;
        } else if ($incomeRange == "440") {
          $scope.cIncomeRange = 1;
          $scope.incomeRange = "weekly";
          $scope.income = "£ 440";
          $scope.cIncome = 440;
        } else {
          $scope.cIncomeRange = 1;
        }
        $scope.updatePlea();
        $scope.updateOffences();
        $scope.refreshMobileSummary();
        $scope.refreshMobileSummary2();
      };

      $scope.updatePlea = function () {
        console.log(
          "Please Value in Update Plea Function = " + $scope.pleaValue
        );
        if ($scope.allOffences[$scope.selectedOffence].plea != 0) {
          $scope.allOffences[$scope.selectedOffence].beforePlea =
            (($scope.cIncome / $scope.cIncomeRange) *
              $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
            100;

          $scope.allOffences[$scope.selectedOffence].afterPlea =
            ($scope.cIncome *
              $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
              $scope.cIncomeRange /
              100 -
            ((($scope.cIncome / $scope.cIncomeRange) *
              $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
              100) *
              $scope.pleaValue;

          console.log(
            "After Plea in Update Plea Function (!0)= " +
              $scope.allOffences[$scope.selectedOffence].afterPlea
          );
          if (
            $scope.allOffences[$scope.selectedOffence].afterPlea >
            $scope.cafterPlea
          ) {
            $scope.cafterPlea =
              $scope.allOffences[$scope.selectedOffence].afterPlea;
          }

          $scope.updateMaximumSentence();
          $scope.updateVictimSur();
        } else {
          $scope.allOffences[$scope.selectedOffence].beforePlea =
            (($scope.cIncome / $scope.cIncomeRange) *
              $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
            100;

          $scope.allOffences[$scope.selectedOffence].afterPlea =
            ($scope.cIncome *
              $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
            $scope.cIncomeRange /
            100;

          console.log(
            "After Plea in Update Plea Function (0)= " +
              $scope.allOffences[$scope.selectedOffence].afterPlea
          );
          $scope.updateMaximumSentence();
          $scope.updateVictimSur();
        }
      };
      // this is an update
      $scope.updateVictimSur = function () {
        var afterPlea = "";
        if ($scope.surcharge == "%10%") {
          //afterPlea = $scope.getBiggestAfterPlea();
          afterPlea = $scope.getTotalAterPlea();
          if (afterPlea < 34) {
            $scope.cSurcharge = "34";
            $scope.cSurchargeViews = "34";
            $scope.cSurchargeView = "34";
          } else if (afterPlea > 190) {
            $scope.cSurcharge = "190";
            $scope.cSurchargeView = "190";
          } else {
            $scope.cSurcharge = afterPlea.toString();
            $scope.cSurchargeView = afterPlea.toString();
          }
        } else if ($scope.surcharge == "10%") {
          //afterPlea = $scope.getBiggestAfterPlea();
          afterPlea = $scope.getTotalAterPlea();
          if (afterPlea < 32) {
            $scope.cSurcharge = "32";
            $scope.cSurchargeViews = "32";
            $scope.cSurchargeView = "32";
          } else if (afterPlea > 181) {
            $scope.cSurcharge = "181";
            $scope.cSurchargeView = "181";
          } else {
            $scope.cSurcharge = afterPlea.toString();
            $scope.cSurchargeView = afterPlea.toString();
          }
        } else if ($scope.surcharge == "40%") {
          //afterPlea = $scope.getBiggestAfterPlea();
          afterPlea = $scope.getTotalAterPlea40();
          if (afterPlea > 2000) {
            $scope.cSurcharge = "2000";
            $scope.cSurchargeView = "2000";
          } else {
            $scope.cSurcharge = afterPlea.toString();
            $scope.cSurchargeView = afterPlea.toString();
          }
        } else {
          $scope.cSurcharge = $scope.surcharge;
          $scope.cSurchargeView = $scope.surcharge;
        }
      };

      $scope.refreshOffences = function () {
        $scope.bandRangeFunc("false");
        $scope.afterPleaFunc($scope.allOffences[$scope.selectedOffence].plea);
        $scope.html = " ";
        angular.forEach($scope.allOffences, function (value, key) {
          key = key + 1;
          if (key == $scope.selectedOffence + 1) {
            $scope.html +=
              '<div id="offence' +
              key +
              '" class="offence-tab offence-selector active">Offence ' +
              key +
              "</div>";
          } else {
            $scope.html +=
              '<div id="offence' +
              key +
              '" class="offence-tab offence-selector" style="cursor:pointer;" ng-click="selectOffence(' +
              key +
              ');">Offence ' +
              key +
              "</div>";
          }
          //$scope.remove = ('<button id="removeOffence'+$key+'" class="btn btn-remove" type="button" ng-click="removeOffence('+$key+');">Remove</button>');
        });
        //$scope.allOffences.forEach(logArrayElements);
      };

      $scope.refreshMobileSummary2 = function () {
        $scope.table2 = "";
        angular.forEach($scope.allOffences, function (value, key) {
          key = key + 1;
          if (key == 1) {
            $scope.table2 +=
              '<tr class="title"><td class="tb-offence tb-offence-title"><span class="offence">Offence ' +
              key +
              "</span><span>Subtotal: £" +
              $scope.roundNumber(
                $scope.summarySubTotal(value.afterPlea, value.compensation),
                2
              ) +
              '</span><i class="fa fa-times btn-remove" style="width: auto; float: left;" aria-hidden="true" ng-click="removeOffence(' +
              key +
              ');"></i><button class="btn btn-review" style="width: auto; float: right;" type="button" ng-click="reviewMobileOffence(' +
              key +
              ');">Review</button></td>';
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="tb-left tb-offence' + key + '">';
            $scope.table2 += '<td class="tb-offence">Starting point</td>';
            $scope.table2 += '<td class="tb-offence">%</td>';
            $scope.table2 += '<td class="tb-offence">Guilty plea</td>';
            $scope.table2 += '<td class="tb-offence">Fine before plea</td>';
            $scope.table2 += '<td class="tb-offence">Fine after plea</td>';
            $scope.table2 += '<td class="tb-offence">Compensation</td>';
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="tb-right tb-offence' + key + '">';
            $scope.table2 +=
              '<td class="tb-offence">' + $scope.getBand(value.band) + "</td>";
            $scope.table2 +=
              '<td class="tb-offence">' +
              $scope.getStartingPoint(value.startingPoint.value) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">' +
              $scope.summaryGuiltyPlea(value.plea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' +
              $scope.summaryBeforePlea(value.beforePlea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' +
              $scope.summaryAfterPlea(value.afterPlea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' + value.compensation + "</td>";
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="edit">';
            $scope.table2 +=
              '<td class="tb-offence tb-offence' +
              key +
              '" style="width: 100%"><button class="btn btn-edit" type="button btn btn-edit" ng-click="selectOffence(' +
              key +
              ',true);">Edit</button></td>';
            $scope.table2 += "</tr>";
          } else {
            $scope.table2 +=
              '<tr class="title"><td class="tb-offence tb-offence-title review"><span class="offence">Offence ' +
              key +
              "</span><span>Subtotal: £" +
              $scope.roundNumber(
                $scope.summarySubTotal(value.afterPlea, value.compensation),
                2
              ) +
              '</span><i class="fa fa-times btn-remove" style="width: auto; float: left;" aria-hidden="true" ng-click="removeOffence(' +
              key +
              ');"></i><button class="btn btn-review" style="width: auto; float: right;" type="button" ng-click="reviewMobileOffence(' +
              key +
              ');">Review</button></td>';
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="tb-left tb-offence' + key + '">';
            $scope.table2 += '<td class="tb-offence">Starting point</td>';
            $scope.table2 += '<td class="tb-offence">%</td>';
            $scope.table2 += '<td class="tb-offence">Guilty plea</td>';
            $scope.table2 += '<td class="tb-offence">Fine before plea</td>';
            $scope.table2 += '<td class="tb-offence">Fine after plea</td>';
            $scope.table2 += '<td class="tb-offence">Compensation</td>';
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="tb-right tb-offence' + key + '">';
            $scope.table2 +=
              '<td class="tb-offence">' + $scope.getBand(value.band) + "</td>";
            $scope.table2 +=
              '<td class="tb-offence">' +
              $scope.getStartingPoint(value.startingPoint.value) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">' +
              $scope.summaryGuiltyPlea(value.plea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' +
              $scope.summaryBeforePlea(value.beforePlea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' +
              $scope.summaryAfterPlea(value.afterPlea) +
              "</td>";
            $scope.table2 +=
              '<td class="tb-offence">£' + value.compensation + "</td>";
            $scope.table2 += "</tr>";
            $scope.table2 += '<tr class="edit">';
            $scope.table2 +=
              '<td class="tb-offence tb-offence' +
              key +
              '" style="width: 100%"><button class="btn btn-edit" type="button btn btn-edit" ng-click="selectOffence(' +
              key +
              ',true);">Edit</button></td>';
            $scope.table2 += "</tr>";
          }
          // angular.forEach(value, function(value, key) {
          //   log(key + ': ' + value);
          // });
        });
      };

      $scope.refreshMobileSummary = function () {
        $scope.table = "";
        $scope.table += "<thead>";
        $scope.table += '<tr class="title">';
        $scope.table += '<th class="fines">Fines</th>';
        $scope.table += '<th class="startingpoint">Starting point</th>';
        $scope.table += '<th class="guiltyplea">Guilty plea</th>';
        $scope.table += '<th class="finebeforeplea">Fine before plea</th>';
        $scope.table += '<th class="fineafterplea">Fine after plea</th>';
        $scope.table += '<th class="compensation">Compensation</th><th></th>';
        $scope.table += "</tr>";
        $scope.table += "</thead>";
        $scope.table += "<tfoot>";
        $scope.table += "<tr>";
        $scope.table += "<td></td>";
        $scope.table += "<td></td>";
        $scope.table += '<td class="text-center"><strong>Total</strong></td>';
        $scope.table +=
          '<td class="text-center"><strong>£' +
          $scope.getFineBeforePleaSubTotal() +
          "</strong></td>";
        $scope.table +=
          '<td class="text-center"><strong><strong>£' +
          $scope.getFineAfterPleaSubTotal() +
          "</strong></td>";
        $scope.table +=
          '<td class="text-center"><strong>£' +
          $scope.getCompenstationSubTotal() +
          "</strong></td><td></td>";
        $scope.table += "</tr>";
        $scope.table += "</tfoot>";
        $scope.table += "<tbody>";
        angular.forEach($scope.allOffences, function (value, key) {
          //console.log($scope.allOffences.length);
          key = key + 1;
          if ($scope.allOffences.length == 1) {
            $scope.table += '<tr class="offence-row">';
            $scope.table +=
              '<td class="offence-title single-offence"><span>Offence ' +
              key +
              "</span></td>";
            $scope.table +=
              "<td>" +
              $scope.getBand(value.band) +
              " " +
              $scope.getStartingPoint(value.startingPoint.value) +
              "</td>";
            $scope.table +=
              "<td>" + $scope.summaryGuiltyPlea(value.plea) + "</td>";
            $scope.table +=
              "<td>£" + $scope.summaryBeforePlea(value.beforePlea) + "</td>";
            $scope.table +=
              "<td>£" + $scope.summaryAfterPlea(value.afterPlea) + "</td>";
            $scope.table += "<td>£" + value.compensation + "</td>";
            $scope.table +=
              '<td class="offence-edit"><button class="btn btn-edit" type="button" ng-click="selectOffence(' +
              key +
              ',true);">Edit</button></td>';
            $scope.table += "</tr>";
          } else {
            $scope.table += '<tr class="offence-row">';
            $scope.table +=
              '<td class="offence-title"><i class="fa fa-times" aria-hidden="true" ng-click="removeOffence(' +
              key +
              ');"></i><span>Offence ' +
              key +
              "</span></td>";
            $scope.table +=
              "<td>" +
              $scope.getBand(value.band) +
              " " +
              $scope.getStartingPoint(value.startingPoint.value) +
              "</td>";
            $scope.table +=
              "<td>" + $scope.summaryGuiltyPlea(value.plea) + "</td>";
            $scope.table +=
              "<td>£" + $scope.summaryBeforePlea(value.beforePlea) + "</td>";
            $scope.table +=
              "<td>£" + $scope.summaryAfterPlea(value.afterPlea) + "</td>";
            $scope.table += "<td>£" + value.compensation + "</td>";
            $scope.table +=
              '<td class="offence-edit"><button class="btn btn-edit" type="button" ng-click="selectOffence(' +
              key +
              ',true);">Edit</button></td>';
            $scope.table += "</tr>";
          }
        });
        $scope.table += "</tbody>";
      };

      $scope.backBtn = function () {
        jQuery(".step1").show();
        jQuery(".step2").hide();
        jQuery("#back_btn").hide();
      };

      $scope.selectOffence = function ($value, $startPage) {
        if ($startPage) {
          jQuery(".step1").show();
          jQuery(".step2").hide();
          jQuery("#back_btn").hide();
          jQuery(".surcharge-info").hide();
        }
        $scope.selectedOffence = $value - 1;
        // console.log($scope.selectedOffence);
        $scope.refreshOffences();
      };

      $scope.addOffence = function ($startPage) {
        if ($startPage) {
          jQuery(".step1").show();
          jQuery(".step2").hide();
          jQuery(".surcharge-info").hide();
        }
        //console.log($scope.allOffences.length);
        $scope.allOffences.push(new offences());
        //console.log($scope.allOffences.length);
        //console.log($scope.allOffences);
        $scope.selectedOffence = $scope.allOffences.length - 1;
        // console.log($scope.selectedOffence);
        if ($scope.allOffences.length <= 1) {
          jQuery(".offence-button-container").hide();
        } else {
          jQuery(".offence-button-container").show();
        }
        if ($scope.allOffences.length >= 6) {
          jQuery(".addOffence").attr("disabled", true);
          jQuery(".addOffence").addClass("btn-disabled");
        }
        $scope.allOffences[$scope.selectedOffence].maximumSentence = 5;
        $scope.refreshOffences();
        $scope.updateVictimSur();
        //console.log($scope.allOffences);
      };

      $scope.removeOffence = function ($value) {
        $scope.allOffences.splice($value - 1, 1);
        $scope.selectedOffence = $scope.allOffences.length - 1;
        $scope.allOffences.forEach(logArrayElements);
        if ($scope.allOffences.length < 6) {
          jQuery(".addOffence").removeAttr("disabled");
          jQuery(".addOffence").removeClass("btn-disabled");
        }
        if ($scope.allOffences.length <= 1) {
          jQuery(".offence-button-container").hide();
        } else {
          jQuery(".offence-button-container").show();
        }
        $scope.refreshOffences();
        $scope.refreshMobileSummary();
        $scope.refreshMobileSummary2();
        $scope.updateVictimSur();
      };

      $scope.startNewCalculation = function ($value) {
        $scope.allOffences = [];

        $scope.selectedOffence = 0;
        $scope.prosecutionCost = 0;
        $scope.maximumSentence = 5;

        $scope.income = "£ 120";
        $scope.cIncome = 120;
        $scope.cIncomeRange = 1;
        $scope.incomeRange = "weekly";

        $scope.cost = "";
        $scope.cCost = 0;
        $scope.cCostView = 0;

        $scope.pleaValue = parseFloat(1 / 3);
        $scope.pleaPercent = "";

        $scope.cAmountHolder = "";
        $scope.vsAmountHolder = "";
        $scope.cccAmountHolder = "";
        $scope.ccAmountHolder = "";

        $scope.surcharge = 0;
        $scope.cSurcharge = 0;
        $scope.cSurchargeView = 0;

        $scope.allOffences.push(new offences());
        jQuery(".addOffence").removeAttr("disabled");
        jQuery(".addOffence").removeClass("btn-disabled");
        jQuery("#offenceBeforeApril2016").removeClass("btn-selected");
        jQuery("#offenceBeforeApril2016").removeAttr("disabled");
        jQuery("#offenceAfterApril2016").removeClass("btn-selected");
        jQuery("#offenceAfterApril2016").removeAttr("disabled");
        jQuery(".step1").show();
        jQuery(".step2").hide();
        jQuery(".prosecutionCost").removeClass("prosecutionCostVisible");
        jQuery(".victimSurcharge").hide();
        jQuery(".offence-button-container").hide();
        $scope.refreshOffences();
        jQuery(".surcharge-info").hide();

        $scope.allOffences[$scope.selectedOffence].maximumSentence = 5;
      };

      $scope.reviewOffence = function () {
        $scope.getFinesSubTotal();
        jQuery(".step1").hide();
        jQuery(".step2").show();
        jQuery(".surcharge-info").show();
        jQuery(".surchargeOption2").hide();
        //jQuery("#back_btn").show();
        if (jQuery("#offenceBeforeApril2016").hasClass("btn-selected")) {
          //console.log("Skipping already selected");
          $scope.offenceBeforeApril2016();
        } else if (jQuery("#offenceAferApril2016").hasClass("btn-selected")) {
          $scope.offenceAfterApril2016();
        } else {
          $scope.offenceAfterApril2020();
        }
        $scope.updateVictimSur();
        $scope.refreshMobileSummary();
        $scope.refreshMobileSummary2();
      };

      $scope.reviewMobileOffence = function (offence) {
        jQuery("table.mobile .tb-offence" + offence).toggle();
      };

      $scope.roundNumber = function (number, precision) {
        precision = Math.abs(parseInt(precision)) || 0;
        var multiplier = Math.pow(10, precision);
        return Math.floor(number * multiplier) / multiplier;
      };

      $scope.summaryBeforePlea = function ($value) {
        return Math.floor($value);
      };

      $scope.summaryAfterPlea = function ($value) {
        return Math.floor($value);
      };

      $scope.summaryGuiltyPlea = function ($plea) {
        if ($plea == "3") {
          return "1/3";
        } else if ($plea == "4") {
          return "1/4";
        } else if ($plea == "10") {
          return "1/10";
        } else if ($plea == "0" || $plea == "-") {
          return "-";
        }
      };

      $scope.summarySubTotal = function ($afterPlea, $compenstation) {
        return parseFloat(Math.floor($afterPlea)) + parseFloat($compenstation);
      };

      $scope.getCompenstationValue = function ($compenstation) {
        return "£ " + $compenstation;
      };

      $scope.getStartingPoint = function ($startingPoint) {
        if ($startingPoint == "0") {
          return "-";
        } else {
          return $startingPoint + "%";
        }
      };

      $scope.getBand = function ($band) {
        if ($band == "None") {
          return "-";
        } else {
          return $band;
        }
      };

      $scope.getFinesSubTotal = function () {
        var subTotalAfterPlea = 0;
        angular.forEach($scope.allOffences, function (value, key) {
          subTotalAfterPlea = Math.floor(value.afterPlea) + subTotalAfterPlea;
        });
        return Math.floor(subTotalAfterPlea);
      };

      $scope.getFineBeforePlea = function () {
        return Math.floor(
          (($scope.cIncome / $scope.cIncomeRange) *
            $scope.allOffences[$scope.selectedOffence].startingPoint.value) /
            100
        );
      };

      $scope.getFineBeforePleaSubTotal = function () {
        var FineBeforePlea = 0;
        angular.forEach($scope.allOffences, function (value, key) {
          FineBeforePlea =
            parseFloat(value.beforePlea) + parseFloat(FineBeforePlea);
        });
        return Math.floor(FineBeforePlea);
        //return FineBeforePlea.toFixed(2);
      };

      $scope.getFineAfterPlea = function () {
        return Math.floor($scope.allOffences[$scope.selectedOffence].afterPlea);
      };

      $scope.getFineAfterPleaSubTotal = function () {
        var FineAfterPlea = 0;
        angular.forEach($scope.allOffences, function (value, key) {
          //console.log("Fine Before: "+ value.afterPlea);
          //console.log("Fine After: "+ Math.round(value.afterPlea));
          FineAfterPlea =
            parseFloat(Math.floor(value.afterPlea)) + parseFloat(FineAfterPlea);
        });
        //console.log("Fine Before Rounding: "+FineAfterPlea);
        return Math.floor(FineAfterPlea);
        //return FineAfterPlea.toFixed(2);
      };

      $scope.getCompenstationSubTotal = function () {
        var subTotalcompensation = 0;
        angular.forEach($scope.allOffences, function (value, key) {
          subTotalcompensation =
            parseFloat(value.compensation) + parseFloat(subTotalcompensation);
        });
        //return Math.floor(subTotalcompensation);
        return subTotalcompensation;
      };

      $scope.getGrandTotal = function () {
        return (
          parseFloat(Math.floor($scope.getFinesSubTotal())) +
          parseFloat($scope.getCompenstationSubTotal()) +
          parseFloat(Math.floor($scope.cSurcharge)) +
          parseFloat($scope.cCost)
        );
      };

      $scope.getBiggestAfterPlea = function () {
        var highestValue = [];
        angular.forEach($scope.allOffences, function (value, key) {
          highestValue.push(value.afterPlea);
        });
        return Math.floor(Math.max.apply(Math, highestValue) / 10);
      };

      $scope.getTotalAterPlea = function () {
        //console.log("getTotalAfterPlea");
        //console.log(Math.round($scope.getFineAfterPleaSubTotal()/10));
        return Math.round($scope.getFineAfterPleaSubTotal() / 10);
      };

      $scope.getTotalAterPlea40 = function () {
        //console.log("getTotalAfterPlea");
        //console.log(Math.round($scope.getFineAfterPleaSubTotal()/10));
        return Math.round(($scope.getFineAfterPleaSubTotal() * 40) / 100);
      };

      $scope.offenceBeforeApril2016 = function () {
        1;
        jQuery("#offenceBeforeApril2016").addClass("btn-selected");
        jQuery("#offenceBeforeApril2016").attr("disabled", true);
        jQuery("#offenceAfterApril2020").attr("disabled", true);
        jQuery("#offenceAfterApril2016").removeClass("btn-selected");
        jQuery("#offenceAfterApril2016").removeAttr("disabled");
        jQuery("#offenceAfterApril2020").removeClass("btn-selected");
        jQuery("#offenceAfterApril2020").removeAttr("disabled");
        jQuery(".prosecutionCost").addClass("prosecutionCostVisible");
        jQuery(".victimSurcharge").show();
        jQuery(".surchargeOption1").show();
        jQuery(".surchargeOption2").hide();
        jQuery(".surchargeOption3").hide();
        $scope.cSurchargeView = 0;
        $scope.cSurcharge = 0;
        jQuery(".vc-height").height(0);
        $scope.vs_description = "";
      };

      $scope.offenceAfterApril2016 = function () {
        jQuery("#offenceAfterApril2016").addClass("btn-selected");
        jQuery("#offenceAfterApril2016").attr("disabled", true);
        jQuery("#offenceAfterApril2020").attr("disabled", true);
        jQuery("#offenceBeforeApril2016").removeClass("btn-selected");
        jQuery("#offenceBeforeApril2016").removeAttr("disabled");
        jQuery("#offenceAfterApril2020").removeClass("btn-selected");
        jQuery("#offenceAfterApril2020").removeAttr("disabled");
        jQuery(".prosecutionCost").addClass("prosecutionCostVisible");
        jQuery(".victimSurcharge").show();
        jQuery(".surchargeOption2").show();
        jQuery(".surchargeOption1").hide();
        jQuery(".surchargeOption3").hide();
        $scope.cSurchargeView = 0;
        $scope.cSurcharge = 0;
        jQuery(".vc-height").height(0);
        $scope.vs_description = "";
        // console.log("Successfully ran");
      };

      $scope.offenceAfterApril2020 = function () {
        jQuery("#offenceAfterApril2020").addClass("btn-selected");
        jQuery("#offenceAfterApril2020").attr("disabled", true);
        jQuery("#offenceAfterApril2016").attr("disabled", true);
        jQuery("#offenceBeforeApril2016").removeClass("btn-selected");
        jQuery("#offenceBeforeApril2016").removeAttr("disabled");
        jQuery("#offenceAfterApril2016").removeClass("btn-selected");
        jQuery("#offenceAfterApril2016").removeAttr("disabled");
        jQuery(".prosecutionCost").addClass("prosecutionCostVisible");
        jQuery(".victimSurcharge").show();
        jQuery(".surchargeOption2").hide();
        jQuery(".surchargeOption1").hide();
        jQuery(".surchargeOption3").show();
        $scope.cSurchargeView = 0;
        $scope.cSurcharge = 0;
        jQuery(".vc-height").height(0);
        $scope.vs_description = "";
        // console.log("Successfully ran");
      };

      $scope.hideFineFields = function ($visibility) {
        if ($visibility) {
          jQuery(".startingPoint").hide();
          jQuery(".guiltyPlea").hide();
          jQuery(".beforeAfterPlea").hide();
        } else {
          jQuery(".startingPoint").show();
          jQuery(".guiltyPlea").show();
          jQuery(".beforeAfterPlea").show();
        }
      };
    });

    app.directive("dynamic", function ($compile) {
      return {
        restrict: "A",
        replace: true,
        link: function (scope, ele, attrs) {
          scope.$watch(attrs.dynamic, function (html) {
            ele.html(html);
            $compile(ele.contents())(scope);
          });
        },
      };
    });

    app.directive("removeButton", function ($compile) {
      return {
        restrict: "A",
        replace: true,
        link: function (scope, ele, attrs) {
          scope.$watch(attrs.dynamic, function (html) {
            ele.html(html);
            $compile(ele.contents())(scope);
          });
        },
      };
    });

    //////////////////////////////////
    //   Jquery - Offence Search   //
    ////////////////////////////////

    jQuery(function () {
      $("ul.droptrue").sortable({
        connectWith: "ul",
        scroll: true,
        handle: ".handle",
      });
      $("ul.dropfalse").sortable({
        connectWith: "ul",
        dropOnEmpty: false,
        scroll: true,
        handle: ".handle",
      });
      $("#sortable1, #sortable2, #sortable3").disableSelection();
    });

    jQuery(function ($) {
      $('input[type="text"].offences-search-input').keyup(function () {
        var searchText = $(this).val();
        $("ul.offences-filter-list > li").each(function () {
          var currentLiText = $(this).text(),
            showCurrentLi =
              currentLiText.toLowerCase().indexOf(searchText.toLowerCase()) !==
              -1;
          $(this).toggle(showCurrentLi);
        });
      });
    });

    jQuery(function ($) {
      $('input[type="text"].adult-search-input').keyup(function () {
        var searchText = $(this).val();
        var searchCat =
          document.getElementById("cat-adult").options[
            adultdropdown.selectedIndex
          ].value;
        $("ul.adult-filter-list > li").each(function () {
          if (searchCat == -1) {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1;
          } else {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1 &&
                currentLiText.indexOf(searchCat) !== -1;
          }
          $(this).toggle(showCurrentLi);
        });
      });
    });

    jQuery(function ($) {
      $('input[type="text"].youth-search-input').keyup(function () {
        var searchText = $(this).val();
        var searchCat =
          document.getElementById("cat-youth").options[
            youthdropdown.selectedIndex
          ].value;
        $("ul.youth-filter-list > li").each(function () {
          if (searchCat == -1) {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1;
          } else {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1 &&
                currentLiText.indexOf(searchCat) !== -1;
          }
          $(this).toggle(showCurrentLi);
        });
      });
    });

    jQuery(function ($) {
      $('input[type="text"].odelolion-search-input').keyup(function () {
        var searchText = $(this).val();
        var searchCat =
          document.getElementById("cat-odelolion").options[
            odeloliondropdown.selectedIndex
          ].value;
        $("ul.odelolion-filter-list > li").each(function () {
          if (searchCat == -1) {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1;
          } else {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1 &&
                currentLiText.indexOf(searchCat) !== -1;
          }
          $(this).toggle(showCurrentLi);
        });
      });
    });

    jQuery(function ($) {
      $('input[type="text"].leuenctid-search-input').keyup(function () {
        var searchText = $(this).val();
        var searchCat =
          document.getElementById("cat-leuenctid").options[
            leuenctiddropdown.selectedIndex
          ].value;
        $("ul.leuenctid-filter-list > li").each(function () {
          if (searchCat == -1) {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1;
          } else {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1 &&
                currentLiText.indexOf(searchCat) !== -1;
          }
          $(this).toggle(showCurrentLi);
        });
      });
    });

    jQuery(function ($) {
      $('input[type="text"].family-search-input').keyup(function () {
        var searchText = $(this).val();
        var searchCat =
          document.getElementById("cat-family").options[
            familydropdown.selectedIndex
          ].value;
        $("ul.family-filter-list > li").each(function () {
          if (searchCat == -1) {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1;
          } else {
            var currentLiText = $(this).text(),
              showCurrentLi =
                currentLiText
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) !== -1 &&
                currentLiText.indexOf(searchCat) !== -1;
          }
          $(this).toggle(showCurrentLi);
        });
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/calculator.js